import { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import logoLight from "../../assets/images/nextskillAI_light.WebP";
import logoDark from "../../assets/images/nextskillAI_dark.WebP";

const FOOTER_LINKS = {
  Company: [
    { label: "About Us", to: "/about" },
    { label: "Careers", to: "/careers" },
    { label: "Blog", to: "/blog" },
    { label: "Press", to: "/press" },
    { label: "Contact", to: "/contact" },
  ],
  Courses: [
    { label: "Excel", to: "/tutorials/basic-excel" },
    { label: "SQL", to: "/tutorials/basic-sql" },
    { label: "Python", to: "/tutorials/python-basics" },
    { label: "Power BI", to: "/tutorials/powerbi" },
    { label: "Machine Learning", to: "/tutorials/ml" },
  ],
  Resources: [
    { label: "Tutorials", to: "/tutorials" },
    { label: "Guides", to: "/guides" },
    { label: "FAQs", to: "/faq" },
    { label: "Community", to: "/community" },
    { label: "Support", to: "/support" },
  ],
};

const SOCIALS = [
  {
    label: "Twitter",
    href: "https://twitter.com",
    icon: "𝕏",
  },
  {
    label: "LinkedIn",
    href: "https://linkedin.com",
    icon: "in",
  },
  {
    label: "YouTube",
    href: "https://youtube.com",
    icon: "▶",
  },
  {
    label: "GitHub",
    href: "https://github.com",
    icon: "⧉",
  },
];

function Footer({ theme = "dark" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email || !email.includes("@") || !email.includes(".")) {
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
      return;
    }

    setStatus("loading");

    setTimeout(() => {
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 4000);
    }, 800);
  };

  return (
    <footer className="footer">

      {/* TOP GRADIENT LINE */}
      <div className="footer-accent" />

      <div className="footer-inner">

        {/* BRAND SECTION */}
        <div className="footer-brand">

          <Link to="/" className="footer-logo">
            <img
              src={theme === "dark" ? logoDark : logoLight}
              alt="NextSkillAI"
            />
          </Link>

          <p className="brand-tagline">
            Master real-world data skills, build powerful projects, and launch your career in analytics with confidence.
          </p>

          {/* SOCIAL ICONS */}
          <div className="social-row">
            {SOCIALS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="social-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>

        {/* LINKS */}
        <div className="footer-links-grid">
          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title} className="footer-col">
              <h3 className="col-title">{title}</h3>
              <ul>
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="footer-link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* NEWSLETTER */}
        <div className="newsletter">

          <h3 className="col-title">Stay Updated</h3>

          <p className="newsletter-sub">
            Get weekly insights, free resources, and new course updates. No spam — ever.
          </p>

          <form className="newsletter-form" onSubmit={handleSubscribe}>

            <div className={`input-wrap ${status === "error" ? "error" : ""}`}>

              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={status === "loading" || status === "success"}
              />

              <button type="submit">
                {status === "loading"
                  ? "..."
                  : status === "success"
                  ? "✓"
                  : "→"}
              </button>

            </div>

            {status === "success" && (
              <p className="form-msg form-msg--success">
                ✓ You're subscribed!
              </p>
            )}

            {status === "error" && (
              <p className="form-msg form-msg--error">
                Enter a valid email address
              </p>
            )}

          </form>

          <div className="trust-row">
            <span className="trust-badge">🔒 No spam</span>
            <span className="trust-badge">50K+ learners</span>
          </div>

        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">

        <p className="copyright">
          © {new Date().getFullYear()} NextSkillAI. All rights reserved.
        </p>

        <div className="legal-links">
          <Link to="/privacy">Privacy</Link>
          <span>·</span>
          <Link to="/terms">Terms</Link>
          <span>·</span>
          <Link to="/cookies">Cookies</Link>
        </div>

      </div>

    </footer>
  );
}

export default Footer;